import React from "react";
import { css } from "glamor";
/**
 * Fieldset for uniform padding
 * around form components
 */
const styles = {
    fieldset: css({
        padding: "16px 28px 0",
        margin: "0 auto",
    }),
};

export const Fieldset = ({ children }) => (
    <fieldset {...styles.fieldset}>{children}</fieldset>
);
